import BccRwdPromoList from 'components/Bcc/BccRwdPromoList/BccRwdPromoList';

export default BccRwdPromoList;
